import './styles/index.css';
import Menu from './components/Menu';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Inicio from './pages/Inicio';
import EnQueCreemos from './pages/EnQueCreemos';
import CompendioHistorico from './pages/CompendioHistorico';
import Iglesias from './pages/Iglesias';
import UuidChurch from './pages/Iglesias/Iglesia/[uuid_church]';
import Noticias from './pages/Noticias';
import UuidNews from './pages/Noticias/Noticia/[uuid_news]';
import Documentos from './pages/Documentos';
import EquipoPastoral from './pages/EquipoPastoral';
import Player from './components/Player';
import { useState, useEffect } from 'react';

export default function App() {
    const [audioPlayerOn, setAudioPlayerOn] = useState(false);
    const [playList, setPlayList] = useState();
    useEffect(() => {
        if(localStorage.getItem('player')){
            setAudioPlayerOn(true);
        }
    });
    return (
        <BrowserRouter>
            <Menu
                setAudioPlayerOn={setAudioPlayerOn}
                setPlayList={setPlayList}
            />
            <Routes>
                <Route path="/" element={<Navigate to="/inicio/" replace />} />
                <Route path="/inicio" element={<Inicio />} />
                <Route path="/en-que-creemos" element={<EnQueCreemos />} />
                <Route path="/compendio-historico" element={<CompendioHistorico />} />
                <Route path="/iglesias" element={<Iglesias />} />
                <Route path="/iglesia/:uuid_church" element={<UuidChurch />} />
                <Route path="/noticias" element={<Noticias />} />
                <Route path="/noticia/:uuid_news" element={<UuidNews />} />
                <Route path="/documentos" element={<Documentos />} />
                <Route path="/equipo-pastoral" element={<EquipoPastoral />} />
            </Routes>
            {audioPlayerOn && <Player key={playList} setAudioPlayerOn={setAudioPlayerOn} playList={playList} />}
        </BrowserRouter>
    );
}